import { render } from "./videoList.vue?vue&type=template&id=2c3bb65f"
import script from "./videoList.vue?vue&type=script&lang=js"
export * from "./videoList.vue?vue&type=script&lang=js"

import "./videoList.vue?vue&type=style&index=0&id=2c3bb65f&lang=scss"

import exportComponent from "/home/runner/work/cinema_vue/cinema_vue/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__